<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="7">
        <div style="color: #fccc66; line-height: 30px">
          质量安全检测年度统计
        </div>
        <qualified-year-statistics></qualified-year-statistics>
      </el-col>
      <el-col :span="4">
        <qualified-rate-gauge></qualified-rate-gauge>
      </el-col>
      <el-col :span="10">
        <div style="color: #fccc66; line-height: 30px">质量安全检测记录</div>
        <detect-record-scroll></detect-record-scroll>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import QualifiedRateGauge from './qualified-rate-gauge'
import QualifiedYearStatistics from './qualified-year-statistics'
import DetectRecordScroll from './detect-record-scroll'
export default {
  components: {
    QualifiedRateGauge,
    QualifiedYearStatistics,
    DetectRecordScroll,
  },
  data() {
    return {}
  },
}
</script>


// WEBPACK FOOTER //
// src/components/screen28896/quality-zone/index.vue